import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getMessaging, type Messaging, isSupported } from 'firebase/messaging';

let firebaseApp: FirebaseApp | null = null;
let messaging: Messaging | null = null;
let initializationInFlight: Promise<void> | null = null;

export const getFirebaseConfig = () => {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  };

  if (
    !config.apiKey ||
    !config.authDomain ||
    !config.projectId ||
    !config.messagingSenderId ||
    !config.appId
  ) {
    throw new Error('Firebase configuration missing. Check environment variables.');
  }

  return config;
};

export const initializeFirebase = (): Promise<void> => {
  if (messaging) return Promise.resolve();
  if (initializationInFlight) return initializationInFlight;

  initializationInFlight = (async () => {
    if (getApps().length === 0) {
      firebaseApp = initializeApp(getFirebaseConfig());
    } else {
      firebaseApp = getApps()[0];
    }

    if (firebaseApp && (await isSupported())) {
      messaging = getMessaging(firebaseApp);
      console.log('Firebase initialized successfully');
    } else {
      console.warn('Firebase Messaging not supported in this browser');
    }
  })().finally(() => {
    initializationInFlight = null;
  });

  return initializationInFlight;
};

export const getMessagingInstance = (): Messaging | null => {
  return messaging;
};
